import React from "react";

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> { }

export const CustomDateInput = React.forwardRef<HTMLInputElement, CustomInputProps>(
    ({ value, onClick, disabled, className }, ref) => {
        return (
            <input
                type="text"
                value={value}
                onClick={onClick}
                disabled={disabled}
                readOnly // Prevent keyboard from appearing
                ref={ref}
                placeholder={"Select Date"}
                className={className}
            />
        )
    }
);

CustomDateInput.displayName = "CustomDateInput";
